import { createGenericDispatcher } from '../action-dispatcher-factory';

import { UserApiClient } from '../../api/user-api-client';

export const createUser = (user: UserRequest) =>
  createGenericDispatcher<User | { warningMessage: string }>({
    name: 'CREATE_USER',
    loadFunction: () => UserApiClient.create(user),
    args: { user },
  });
